import { BuiltInComponents } from 'craft/constants';
import { CssSelectorId } from 'craft/types';

export const SET_EDITOR_STYLEGUIDE = 'Editor/Styleguide/SET_EDITOR_STYLEGUIDE';

/**
 * Maintains a mapping between styleguide classes to css selectors.
 * We need this mapping because we otherwise don't know how to translate
 * one into the other, as the formats are slighly different.
 */
export const styleguideSelectorsToCssSelectorIds: Record<string, CssSelectorId> = {
  // Typography
  '.candu-link': CssSelectorId.TypographyHrefChildren,

  // Modal
  '.candu-modalV2 .candu-modalV2--backdrop': CssSelectorId.ModalBackdrop,
  '.candu-modalV2 .candu-modalV2--container': CssSelectorId.ModalContainer,
  '.candu-modalV2--container > .candu-dismiss-wrapper': CssSelectorId.OverlayDismiss,
  '.candu-modalV2--container > .candu-dismiss-wrapper .candu-dismiss-svg':
    CssSelectorId.OverlayDismissSVG,

  // Forms
  '.candu-form .candu-form--input-field.error': CssSelectorId.FormError,
  '.candu-form .candu-form--input-field': CssSelectorId.FormTextInput,
  '.candu-form textarea.candu-form--input-field': CssSelectorId.FormTextArea,
  '.candu-form select.candu-form--input-field': CssSelectorId.FormSelectInput,
  '.candu-form .candu-form--checkbox-div': CssSelectorId.FormCheckboxListDiv,

  // Hotspots
  '.candu-h-beacon svg': CssSelectorId.HotspotBeaconSVG,
  '.candu-h-wrapper .candu-h-arrow': CssSelectorId.HotspotArrow,
  '.candu-h-wrapper': CssSelectorId.HotspotWrapper,
  '.candu-h-wrapper .candu-h-body': CssSelectorId.HotspotBody,
  '.candu-h-wrapper .candu-h-container > .candu-dismiss-wrapper': CssSelectorId.HotspotDismiss,
  '.candu-h-wrapper .candu-h-container > .candu-dismiss-wrapper .candu-dismiss-svg':
    CssSelectorId.HotspotDismissSVG,
  // Hotspots legacy selectors for backward compatibility
  '.candu-h-arrow': CssSelectorId.HotspotArrow,
  '.candu-h-body': CssSelectorId.HotspotBody,
  '.candu-h-wrapper .candu-dismiss-wrapper': CssSelectorId.HotspotDismiss,
  '.candu-h-wrapper .candu-dismiss-svg': CssSelectorId.HotspotDismissSVG,

  // Tour
  '.candu-t-backdrop-container': CssSelectorId.TourStepBackdropContainer,
  '.candu-t-backdrop-wrapper': CssSelectorId.TourStepBackdropWrapper,
  '.candu-t-wrapper .candu-t-arrow': CssSelectorId.TourStepArrow,
  '.candu-t-wrapper': CssSelectorId.TourStepWrapper,
  '.candu-t-wrapper .candu-t-body': CssSelectorId.TourStepBody,
  '.candu-t-wrapper .candu-t-container > .candu-dismiss-wrapper': CssSelectorId.TourDismiss,
  '.candu-t-wrapper .candu-t-container > .candu-dismiss-wrapper .candu-dismiss-svg':
    CssSelectorId.TourDismissSVG,
  // Tour legacy selectors for backward compatibility
  '.candu-t-arrow': CssSelectorId.TourStepArrow,
  '.candu-t-body': CssSelectorId.TourStepBody,
  '.candu-t-wrapper .candu-dismiss-wrapper': CssSelectorId.TourDismiss,
  '.candu-t-wrapper .candu-dismiss-svg': CssSelectorId.TourDismissSVG,

  // Cards
  '.candu-card > .candu-dismiss-wrapper': CssSelectorId.CardDismiss,
  '.candu-card > .candu-dismiss-wrapper .candu-dismiss-svg': CssSelectorId.CardDismissSVG,
  // Cards legacy selectors for backward compatibility
  '.candu-card .candu-dismiss-svg': CssSelectorId.CardDismissSVG,
};

/**
 * Some rules references other rules, so we need to manually merge the css object.
 * for example, TextInput has the selector:
 * .candu-form--input-field
 *
 * Which is CSS will apply to all the other  .candu-form--input-field classes.
 * Note: we only maintain the styles that we actually care about here as we don't
 * allow to override all styles in every comopnent.
 */
export const rulesCrossReferences: Record<string, Record<string, string>> = {
  [BuiltInComponents.Form]: {
    [CssSelectorId.FormTextArea]: CssSelectorId.FormTextInput,
    [CssSelectorId.FormSelectInput]: CssSelectorId.FormTextInput,
  },
};

export const customValuesToBeProcessed = [
  '--beacon-color',
  '--hotspot-stroke',
  '--hotspot-stroke-width',
  '--tour-stroke',
  '--tour-stroke-width',
  '--card-stroke',
  '--card-stroke-width',
];
